import { render } from "./CTASection.vue?vue&type=template&id=3addec30&scoped=true"
import script from "./CTASection.vue?vue&type=script&lang=js"
export * from "./CTASection.vue?vue&type=script&lang=js"

import "./CTASection.vue?vue&type=style&index=0&id=3addec30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3addec30"]])

export default __exports__